import { LazyLoadImage } from 'react-lazy-load-image-component'
import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { sendClickPromoDataToAnalytics, sendClickPromoDataToAnalyticsV2 } from '../../common/GoogleTagManager'
import AdvertisingSlot from '../../functional-components/Advertising/AdvertisingSlot'
import { onImpressionHandle, onViewHandle, sendEventOrRedirect } from '../../common/advisorUtil'
import { extractAnalyticDataFromPromoLink } from '../../Helpers'
import './index.css'

const BannerFreeShippingSod = ({ ...props }) => {
  const { isMobile, freeShipping, history, configData, className, origin } = props

  const onClickHandle = (data, navigatorPath) => {
    const { tag, link, target } = data.extraProps
    sendClickPromoDataToAnalytics(tag, origin)
    const analyticData = extractAnalyticDataFromPromoLink(link)
    sendClickPromoDataToAnalyticsV2(analyticData)
    sendEventOrRedirect(data, link, target, navigatorPath)
  }

  const { name, advisor, backgroundMobile, backgroundDesktop, defaultBanner, link, active } = freeShipping
  const image = isMobile ? backgroundMobile : backgroundDesktop
  const isAdvisor = !!(advisor?.mobile || advisor?.desktop)
  const baseUrl = isAdvisor || defaultBanner ? '' : `${configData.storageBaseUrl}/`

  if (!freeShipping || !active) return null

  return (
    <div className={`${className}__container`}>
      <AdvertisingSlot
        isMobile={isMobile}
        advisor={advisor}
        onClick={(data) => onClickHandle(data, history.push)}
        onImpression={onImpressionHandle}
        onView={onViewHandle}
        onVisible={() => {}}
        extraProps={{ ...freeShipping, isMobile }}
        className={`${className}__${link ? '' : 'no-'}link-container`}
        isHistoryPush={true}
      >
        <LazyLoadImage
          alt={`banner-${name}`}
          src={baseUrl + image}
          className="img-fluid"
          style={{
            alignSelf: 'flex-start',
          }}
          data-testid="link-container"
        />
      </AdvertisingSlot>
    </div>
  )
}

export default withRouter(BannerFreeShippingSod)

BannerFreeShippingSod.defaultProps = {
  isMobile: true,
  configData: {},
  history: {},
  freeShipping: {},
  className: {},
  origin: '',
}

BannerFreeShippingSod.propTypes = {
  isMobile: PropTypes.bool,
  configData: PropTypes.object,
  history: PropTypes.object,
  freeShipping: PropTypes.object,
  className: PropTypes.object,
  origin: PropTypes.string,
}
